module.exports = __webpack_public_path__ + "static/media/mission-vision_top.40c24aa6.jpg";